import { useCallback, useState } from 'react'
import classNames from 'classnames'
import useSWR from 'swr'
import './HubToggle.scss'
import { getFrameworkServiceUrl } from '@sparky/framework'
import type { VFC, MouseEvent } from 'react'
import type { UserState } from '@sparky/framework'

type UserHubAvail = {
  accounts: boolean
  tenants: boolean | null
  empty?: boolean
}

export const HUB_CLASSIC_URL = '/apps'
const HUB_URL_KEY = 'app_portal'
const DEFAULT_VALUE = false

const preventDefault = (e: MouseEvent<HTMLAnchorElement>) => {
  e.preventDefault()
}

export const prefetchToggleHub = () => {
  if (document.getElementById('hub-prefetch')) {
    return
  }
  window.requestIdleCallback(() => {
    if (document.getElementById('hub-prefetch')) {
      return
    }
    const link = document.createElement('link')
    link.id = 'hub-prefetch'
    link.rel = 'prefetch'
    link.type = 'document'
    link.href = HUB_CLASSIC_URL
    document.head.appendChild(link)
  }, { timeout: 15000 }) // 15s
}

const prepareToggleHub = () => {
  if (document.getElementById('hub-prerender')) {
    return
  }
  const link = document.createElement('link')
  link.id = 'hub-prerender'
  link.rel = 'prerender'
  link.href = HUB_CLASSIC_URL
  document.head.appendChild(link)
}
const toggleHub = () => {
  window.location.href = HUB_CLASSIC_URL
}
const getHubApiUrl = (url: string) => {
  const baseUrl = getFrameworkServiceUrl(HUB_URL_KEY)
  if (baseUrl && window.location.origin.startsWith(baseUrl)) {
    const fullUrl = new URL(url, getFrameworkServiceUrl(HUB_URL_KEY))
    // fullUrl.hash = ''
    return fullUrl.toString()
  }
  return url
}
const fetcher = async (url: string) => {
  return fetch(getHubApiUrl(url), {
    method: 'GET',
    credentials: 'include',
    mode: 'no-cors',
  }).then(r => r.json())
}
const swrOption = {
  revalidateOnFocus: false,
  dedupingInterval: 10000, // 10s
  loadingTimeout: 5000, // 5s
}

const HubToggle: VFC<{ user: UserState }> = ({ user }) => {
  const [checked, setChecked] = useState<boolean>(DEFAULT_VALUE)
  const onInternalClick = useCallback((e) => {
    e.preventDefault()
    setChecked(!DEFAULT_VALUE)
    setTimeout(toggleHub, 120)
  }, [])

  const classname = classNames('sparky-hub-toggle', {
    'sparky-hub-toggle-checked': checked,
  })

  const userSessId = user.notonorafter || user.subname
  const { data } = useSWR<UserHubAvail>(userSessId && `/hub/v2/user_hub_availibilty#${userSessId}`, fetcher, swrOption)

  if (!data?.accounts) {
    return null
  }

  return (
    <div id='sparky-hub-toggle' className='sparky-hub-toggle-wrap' onMouseOver={prepareToggleHub}>
      <button
        type='button'
        role='switch'
        aria-checked={checked}
        className={classname}
        onClick={onInternalClick}
      ></button>
      View by Support Account
      &nbsp;&nbsp;(<a href='#hub-learn-more' className='!cm-text-blue hover:cm-text-blue' onClick={preventDefault}>Learn more</a> about the new Hub updates)
    </div>
  )
}

HubToggle.displayName = 'HubToggle'

export default HubToggle
